import { z } from 'zod';
import { GitHubAppKindSchema } from '@terra/shared-schemas-git';
import { normalizeGitIntegrationBaseUrl } from './normalize-git-integration-base-url';

export const GitHubEnterpriseWebhookUrlReturnSchema = z.object({
  expectedUrl: z.url(),
});

export const GitHubEnterpriseAppInstallationsBodySchema = z.object({
  baseUrl: z
    .string()
    .trim()
    .min(1)
    .transform((value) => normalizeGitIntegrationBaseUrl(value) ?? value),
  gitHubAppId: z.string().trim().min(1),
  gitHubAppPrivateKey: z.string().trim().min(1),
  gitHubAppKind: GitHubAppKindSchema,
  twingateNetworkId: z.string().nullish(),
  internalAccessNetworkId: z.string().nullish(),
});

export const GitHubEnterpriseAppInstallationSchema = z.object({
  id: z.string(),
  accountLogin: z.string(),
  isConnected: z.boolean(),
});

export const GitHubEnterpriseAppInstallationsReturnSchema = z.object({
  installations: GitHubEnterpriseAppInstallationSchema.array(),
});

export const GitHubEnterpriseStoredAppInstallationsSchema = z.object({
  baseUrl: z.string(),
  gitHubAppId: z.string(),
  gitHubAppKind: GitHubAppKindSchema,
  installations: GitHubEnterpriseAppInstallationSchema.array(),
  error: z.string().nullable(),
});

export const GitHubEnterpriseStoredAppInstallationsReturnSchema = z.object({
  apps: GitHubEnterpriseStoredAppInstallationsSchema.array(),
});

export type GitHubEnterpriseStoredAppInstallationsDto = z.infer<
  typeof GitHubEnterpriseStoredAppInstallationsSchema
>;

export type GitHubEnterpriseAppInstallationsRequestDto = z.infer<
  typeof GitHubEnterpriseAppInstallationsBodySchema
>;

export type GitHubEnterpriseAppInstallationDto = z.infer<
  typeof GitHubEnterpriseAppInstallationSchema
>;
